import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { DevelopersCompanyContext } from 'common/containers/DevelopersCompanyContainer';
import APIDocsSections from 'common/developers/docs/api/APIDocsSections';
import APIDocsHelmet from 'common/helmets/APIDocsHelmet';
import Tappable from 'common/Tappable';
import withContexts from 'common/util/withContexts';

import 'css/components/developers/docs/api/_APIDocs.scss';

class APIDocs extends Component {
  static propTypes = {
    company: PropTypes.object,
    location: PropTypes.object,
    router: PropTypes.object,
  };

  state = {
    activeSectionID: null,
  };

  constructor(props) {
    super(props);

    this.blocksRef = React.createRef();

    this.sectionRefs = {};
    APIDocsSections.forEach((section, i) => {
      this.sectionRefs[section.id] = React.createRef();
    });
  }

  componentDidMount() {
    const blocksContainer = this.blocksRef.current;
    blocksContainer.addEventListener('scroll', this.onScroll, false);

    const {
      location: { hash, pathname },
      router,
    } = this.props;
    if (hash) {
      const sectionID = hash.slice(1);
      if (this.sectionRefs[sectionID].current) {
        this.onSetActiveSection(sectionID);
        this.onScrollToSection(sectionID);
      } else {
        router.replace({
          hash: null,
          pathname,
        });
      }
    }
  }

  componentWillUnmount() {
    const blocksContainer = this.blocksRef.current;
    blocksContainer.removeEventListener('scroll', this.onScroll);
  }

  onScroll = () => {
    const blocksContainer = this.blocksRef.current;
    const scrollTop = blocksContainer.scrollTop;

    for (var i = 0; i < APIDocsSections.length; i++) {
      const section = APIDocsSections[i];
      const sectionComponent = this.sectionRefs[section.id].current;
      if (scrollTop < sectionComponent.offsetTop + sectionComponent.offsetHeight * 0.7) {
        this.onSetActiveSection(section.id);
        return;
      }
    }
  };

  onScrollToSection = (sectionID) => {
    const section = this.sectionRefs[sectionID].current;
    if (!section) {
      return;
    }

    section.scrollIntoView();
  };

  onSetActiveSection = (sectionID) => {
    this.setState({
      activeSectionID: sectionID,
    });

    const {
      location: { hash, pathname },
      router,
    } = this.props;
    if (hash === '#' + sectionID) {
      return;
    }

    router.replace({
      hash: '#' + sectionID,
      pathname: pathname,
    });
  };

  renderSidebar() {
    const { activeSectionID } = this.state;
    const items = [];
    APIDocsSections.forEach((section, i) => {
      if (section.main) {
        const className = 'mainItem' + (activeSectionID === section.id ? ' active' : '');
        items.push(
          <Tappable onTap={this.onScrollToSection.bind(this, section.id)} key={i}>
            <div className={className}>{section.name}</div>
          </Tappable>,
        );
      } else {
        var isActiveSection = false;
        for (let j = i; j >= 0; j--) {
          if (activeSectionID === APIDocsSections[j].id) {
            isActiveSection = true;
            break;
          } else if (APIDocsSections[j].main === true) {
            break;
          }
        }
        for (let j = i; j < APIDocsSections.length; j++) {
          if (APIDocsSections[j].main === true) {
            break;
          } else if (activeSectionID === APIDocsSections[j].id) {
            isActiveSection = true;
            break;
          }
        }
        const style = {
          ...(!isActiveSection && {
            display: 'none',
          }),
        };
        const className = 'item' + (activeSectionID === section.id ? ' active' : '');
        items.push(
          <Tappable onTap={this.onScrollToSection.bind(this, section.id)} key={i}>
            <div className={className} style={style}>
              {section.name}
            </div>
          </Tappable>,
        );
      }
    });

    return <div className="sidebar">{items}</div>;
  }

  renderBlocks() {
    const { company } = this.props;
    const items = [];
    APIDocsSections.forEach((section, i) => {
      items.push(
        <div key={section.id} ref={this.sectionRefs[section.id]} id={section.id}>
          <section.block company={company} onScrollToSection={this.onScrollToSection} />
        </div>,
      );
    });
    return (
      <div className="blocks" ref={this.blocksRef}>
        {items}
      </div>
    );
  }

  render() {
    return (
      <div className="apiDocs">
        <APIDocsHelmet />
        {this.renderSidebar()}
        {this.renderBlocks()}
      </div>
    );
  }
}

export default compose(withContexts({ company: DevelopersCompanyContext }), hot)(APIDocs);
